import { DemandDetail } from '~/api/demands/_types';

export const useDemandDetailStore = defineStore('demand', () => {
    const activeDemand = ref<DemandDetail | null>(null);

    const reset = () => {
        activeDemand.value = null;
    };

    return {
        activeDemand,
        reset,
    };
});
